import { ExploreImageUploadForm } from "@/components/tools/ExploreImageUploadForm";
import { Dialog, DialogContent } from "@/components/ui/dialog";

import { EXPLORE_IMAGE_FULL_SCREEN_DIALOG_CLASS_NAME } from "@/lib/exploreImages";

/**
 * Full-screen upload view that steps through a batch of picked files one at
 * a time. Each file gets its own details; closing drops whatever is left.
 */
export const ExploreImageUploadDialog = ({
  files,
  index,
  onClose,
  onNext,
}: {
  files: File[];
  index: number;
  onClose: () => void;
  onNext: () => void;
}) => {
  const file = index < files.length ? files[index] : null;

  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      open={!!file}
    >
      <DialogContent
        aria-describedby={undefined}
        className={EXPLORE_IMAGE_FULL_SCREEN_DIALOG_CLASS_NAME}
        hideCloseButton
      >
        {file && (
          <ExploreImageUploadForm
            key={index}
            file={file}
            index={index}
            onClose={onClose}
            onDone={onNext}
            total={files.length}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
